import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultant-index-route.tsx
var LazyConsultantIndexRoute = lazy(() => import("./consultant-index-route-DBg8ySGe.js").then((n) => n.n).then((module) => ({ default: module.ConsultantIndexRoute })));
function ConsultantIndexRoute({ route, ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyConsultantIndexRoute, {
			route,
			...props
		})
	});
}
var useConsultantIndexRoute = () => {
	return useMemo(() => ({ "consultants-index-route": { component: ConsultantIndexRoute } }), []);
};
//#endregion
export { useConsultantIndexRoute };
